import React from "react";
import ModalFormEstado from "./ModalFormEstado";

const ModalEstado = ({ show, handleClose, estado }) => {
  return (
    <ModalFormEstado show={show} handleClose={handleClose} estado={estado} />
  );
};

export default ModalEstado;
